import { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getPlan } from '@/services/plans.service';
import { Spinner } from '@/components/ui';

/**
 * Resolves `/plans/:planId` links by fetching the plan's patientId
 * and redirecting to `/patients/:patientId/plans/:planId`.
 *
 * The query string is carried across, so `/plans/5?section=surgery` still opens
 * the Surgery section once the patient is known.
 */
export default function PlanRedirect() {
  const { planId } = useParams<{ planId: string }>();
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const id = Number(planId);
    if (!Number.isFinite(id) || id <= 0) {
      navigate('/plans', { replace: true });
      return;
    }
    getPlan(id)
      .then((plan) => navigate(`/patients/${plan.patientId}/plans/${id}${search}`, { replace: true }))
      .catch(() => navigate('/plans', { replace: true }));
  }, [planId, search, navigate]);

  return (
    <div className="flex items-center justify-center py-24">
      <Spinner className="h-6 w-6" />
    </div>
  );
}
